module.exports = __webpack_public_path__ + "dashboard/img/road-barrier_dark.d66ac88649dc628ddb9d88d68362912e.svg";